// Header.js
import { Link as RouterLink } from 'react-router-dom';
import { Toolbar, AppBar, Box, Link } from '@mui/material';
import { styled } from '@mui/material/styles';
import {
    UserMenu,
    LoadingIndicator,
    LocalesMenuButton,
    useLocales,
    useBasename,
    useThemesContext,
    ToggleThemeButton,
} from 'react-admin';
import { useContainerLayout }  from '@react-admin/ra-navigation';
import CustomHorizontalMenu from './CustomHorizontalMenu'; // Import your custom menu

const Header = (props) => {
    const {
        title = 'React-admin',
        menu = defaultMenu,
        toolbar = defaultToolbar,
        userMenu = defaultUserMenu,
    } = useContainerLayout(props);

    const baseName = useBasename();

    return (
        <Root
            position="static"
            color="secondary"
            className={HeaderClasses.root}
            {...sanitizeRestProps(props)}
        >
            <Toolbar variant="dense" className={HeaderClasses.toolbar}>
                <Box className={HeaderClasses.title}>
                    <Link
                        component={RouterLink}
                        to={`${baseName}/`}
                        variant="h6"
                        color="inherit"
                        underline="none"
                    >
                        {title}
                    </Link>
                </Box>
                <Box className={HeaderClasses.menu}>{menu}</Box>
                <Box className={HeaderClasses.actions}>
                    {toolbar}
                    {typeof userMenu === 'boolean' ? (
                        userMenu === true ? (
                            <UserMenu />
                        ) : null
                    ) : (
                        userMenu
                    )}
                </Box>
            </Toolbar>
        </Root>
    );
};

const PREFIX = 'RaHeader';
const HeaderClasses = {
    root: `${PREFIX}-root`,
    toolbar: `${PREFIX}-toolbar`,
    title: `${PREFIX}-title`,
    menu: `${PREFIX}-menu`,
    actions: `${PREFIX}-actions`,
};

const Root = styled(AppBar, {
    name: PREFIX,
    overridesResolver: (_props, styles) => styles.root,
})({
    [`& .${HeaderClasses.toolbar}`]: {
        flex: 1,
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    [`& .${HeaderClasses.title}`]: {
        display: 'flex',
        alignItems: 'center',
    },
    [`& .${HeaderClasses.menu}`]: {
        alignItems: 'center',
    },
    [`& .${HeaderClasses.actions}`]: {
        display: 'flex',
        alignItems: 'center',
    },
});

const defaultMenu = <CustomHorizontalMenu />; // Use your custom menu
const defaultUserMenu = <UserMenu />;

const sanitizeRestProps = ({ title, menu, userMenu, toolbar, ...props }) => props;

const DefaultToolbar = () => {
    const locales = useLocales();
    const { darkTheme } = useThemesContext();
    return (
        <>
            {locales && locales.length > 1 ? <LocalesMenuButton /> : null}
            {darkTheme && <ToggleThemeButton />}
            <LoadingIndicator />
        </>
    );
};

const defaultToolbar = <DefaultToolbar />;

export default Header;
